import apiBranch from '@/api/branch'

const state = {
  error: null,
  isSubmitting: false,
  isLoading: false,
  branch: null,
  branches: []
}

export const mutationTypes = {
  updateBranchStart: '[update branch] Update branch start',
  updateBranchSuccess: '[update branch] Update branch success',
  updateBranchFailure: '[update branch] Update branch failure',

  getBranchesStart: '[update branches] Get branches start',
  getBranchesSuccess: '[update branches] Get branches success',
  getBranchesFailure: '[update branches] Get branches failure'
}

export const actionTypes = {
  updateBranch: '[update branch] Update branch',
  getBranches: '[update branches] Get branches'
}

const mutations = {
  [mutationTypes.updateBranchStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.updateBranchSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.updateBranchFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  },

  [mutationTypes.getBranchesStart](state) {
    state.isLoading = true
    state.branches = []
  },

  [mutationTypes.getBranchesSuccess](state, payload) {
    state.branches = payload
    state.isLoading = false
  },

  [mutationTypes.getBranchesFailure](state) {
    state.isLoading = false
  }
}

const actions = {
  [actionTypes.updateBranch](context, {id, branchInput}) {
    context.commit(mutationTypes.updateBranchStart)
    return new Promise(resolve => {
      apiBranch
        .updateBranch(id, branchInput)
        .then(response => {
          context.commit(mutationTypes.updateBranchSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.updateBranchFailure,
            resolve.response.data.errors
          )
        })
    })
  },

  [actionTypes.getBranches](context, {schoolId, schoolType}) {
    const params = {
      schoolId,
      schoolType
    }
    context.commit(mutationTypes.getBranchesStart)
    return new Promise(resolve => {
      apiBranch
        .getBranches(params)
        .then(response => {
          context.commit(mutationTypes.getBranchesSuccess, response.data)
          resolve(response.data)
        })
        .catch(() => {
          context.commit(mutationTypes.getBranchesFailure)
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
